import {useContext, useEffect, useRef} from 'react';
import {useToaster} from '@gravity-ui/uikit';
import {ToastVisibilityContext} from 'app/Providers/CustomToasterProvider/ToastVisibilityContext';
import {
    dismissOrderFlowToastsFromQueueUntilGone,
    hideToasterCss,
    isOrderFlowToastName,
    ORDER_SUCCESS_TOAST_NAMES
} from './toastQueueUtils';

/** Снимает тосты оформления заказа из очереди при входе на страницу заказов */
export const useCleanupCheckoutToasts = () => {
    const {remove, has, removeAll} = useToaster();
    const {currentToastName, setCurrentToastName, setIsToasterVisible, bumpToasterInstanceKey} =
        useContext(ToastVisibilityContext);
    const currentToastNameOnMount = useRef(currentToastName);
    const didCleanup = useRef(false);

    useEffect(() => {
        if (didCleanup.current) {
            return;
        }

        didCleanup.current = true;

        void (async () => {
            removeAll();
            await dismissOrderFlowToastsFromQueueUntilGone(remove, has);
            hideToasterCss();
            setIsToasterVisible(false);

            if (isOrderFlowToastName(currentToastNameOnMount.current)) {
                setCurrentToastName(null);
            }

            // Полный reset инстанса ToasterComponent для гарантированного сброса внутренней очереди.
            bumpToasterInstanceKey();
        })();

        // На всей жизни страницы Orders подавляем success-тосты оформления заказа.
        const interval = window.setInterval(() => {
            removeAll();
            ORDER_SUCCESS_TOAST_NAMES.forEach((name) => remove(name));

            if (ORDER_SUCCESS_TOAST_NAMES.every((name) => !has(name))) {
                hideToasterCss();
                setIsToasterVisible(false);

                if (isOrderFlowToastName(currentToastNameOnMount.current)) {
                    setCurrentToastName(null);
                }
            }
        }, 150);

        return () => {
            window.clearInterval(interval);
        };
    }, [removeAll, remove, has, setCurrentToastName, setIsToasterVisible, bumpToasterInstanceKey]);
};
